module.exports = __webpack_public_path__ + "static/img/s5.1e2ef1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s5.png
// module id = AqCb
// module chunks = 1